import React, { type FunctionComponent } from 'react'
import { type PartnerScopedRouteParams } from '../../../legacy/common/types'
import { DashRoute } from '../../../legacy/dash-components/dash-route/DashRoute'
import { DashSwitch } from '../../../legacy/dash-components/dash-switch/DashSwitch'
import { type DashRouteComponentProps } from '../../../legacy/dash-components/dash-route/utils/dashRoute.types'
import { RetailerScopedSection } from './retailer-scoped/RetailerScopedSection'

interface Props extends DashRouteComponentProps<PartnerScopedRouteParams> {}

export const PartnerScopedRoutes: FunctionComponent<Props> = () => (
  <DashSwitch>
    <DashRoute route="retailer-scoped" component={RetailerScopedSection} />
  </DashSwitch>
)
